import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { Observable } from 'rxjs';
import { ArchAlignmentState, ArchAlignmentStore } from './arch-alignment.store';

@Injectable({ providedIn: 'root' })
export class ArchAlignmentQuery extends Query<ArchAlignmentState> {
	readonly onUpperJaw$: Observable<boolean> = this.select(state => state.OnUpperJaw);
	readonly onLowerJaw$: Observable<boolean> = this.select(state => state.OnLowerJaw);

	get state(): ArchAlignmentState {
		return this.getValue();
	}

	constructor(store: ArchAlignmentStore) {
		super(store);
	}
}
